import React, { Component } from 'react';
import config from '../config';

import GoogleTagManager from './components/GoogleTagManager';
import Loader from './components/Loader';
import Header from './components/Header';
import Ankle from './components/Ankle';
import Footer from './components/Footer';
import Cookie from './components/Cookie';

class Layout extends Component {
	componentDidMount() {
		const isMobile = navigator.userAgent.toLowerCase()
					.match(/(iphone|ipod|ipad|android|blackberry|opera mini|iemobile|kindle|silk|mobile)/);
		if (isMobile) {
			const htmlClass = document.documentElement.className;
			document.documentElement.className = htmlClass.replace('no-mobile','mobile');
			// const viewport = document.getElementsByName('viewport')[0];
			// const viewportContent = viewport.getAttribute('content');
			// const updateViewport = function() {
			// 	if (global.matchMedia('(min-width: 768px)').matches) {
			// 		viewport.setAttribute('content',viewportContent.replace('device-width',1366));
			// 	} else {
			// 		viewport.setAttribute('content', viewportContent);
			// 	}
			// };
			// window.addEventListener('orientationchange, deviceorientation', updateViewport, false);
			// updateViewport();
		}
	}

	render() {
		const { children } = this.props;
		return (
			<div>
				<GoogleTagManager gtmId={ config.gtmId } />
				<Loader />
				<Cookie />
				<div className="container">
					<Header />
					<main id="content">
						{ children }
					</main>
					<Ankle />
					<Footer />
				</div>
			</div>
		);
	}
}

export default Layout;


// WEBPACK FOOTER //
// ./src/pages/Layout.js